export default __webpack_public_path__ + "static/media/officeStory.8ce7bfe8.mp3";